import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { usePrevious } from '@plone/volto/helpers/Utils/usePrevious';
import { default as Toast } from '@plone/volto/components/manage/Toast/Toast';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
const useToast = (state_id) => {
  const state = useSelector((state) => {
    if (state_id.includes('.')) {
      const reduced = state_id.split('.').reduce(
        (acc, obj) => {
          acc = acc[obj];
          return acc;
        },
        { ...state },
      );
      return reduced;
    }
    return state[state_id];
  });
  const prevstate = usePrevious(state);

  useEffect(() => {
    if (state.loaded && prevstate?.loading) {
      toast.success(
        <Toast
          success
          title={<FormattedMessage id="Success!" defaultMessage="Success!" />}
        />,
        {
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
        },
      );
    } else if (state.error && prevstate?.loading) {
      toast.error(
        <Toast
          error
          title={
            <FormattedMessage
              id="There was an error, try again later please."
              defaultMessage="There was an error, try again later please."
            />
          }
        />,
        {
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
};
export default useToast;
